import React from "react";
import { useNavigate } from "react-router-dom";

export default function PrinterRow({ printer }) {
  const navigate = useNavigate();
  const {
    printerId,
    isOnline,
    queueDepth,
    lastJobAt,
    deviceName,
    groupName,
    deviceAlias,
  } = printer;

  return (
    <tr>
      <td>{printerId}</td>
      <td>
        <span className={`pm-pill ${isOnline ? "ok" : "err"}`}>
          {isOnline ? "Online" : "Offline"}
        </span>
      </td>
      <td style={{ textAlign: "center" }}>{queueDepth}</td>
      <td>{lastJobAt ? new Date(lastJobAt).toLocaleString() : "—"}</td>
      <td>{deviceAlias || deviceName || "—"}</td>
      <td>{groupName || "—"}</td>
      <td>
        <button
          className="pm-settings-btn"
          onClick={() => navigate(`/printerdetail/${encodeURIComponent(printerId)}`)}
        >
          ⚙️ Settings
        </button>
      </td>
    </tr>
  );
}
